import { useState } from "react"
import AEMAllowedToolsContext from "./AEMAllowedToolsContext"

export function AEMAllowedToolsProvider({
	children
}: {
	children: React.ReactNode
}) {
	const [tools, setTools] = useState<string[]>([])
	const [loaded, setLoaded] = useState(false)

	return (
		<AEMAllowedToolsContext.Provider
			value={{ tools, setTools, loaded, setLoaded }}
		>
			{children}
		</AEMAllowedToolsContext.Provider>
	)
}
